import { Link } from "react-router-dom";

function HomePage(params) {
    // todo:
    // Design the main page, includes -
    // List of services 
    // List of clients
    // Why choose us
    // Offers
    // Pricing 
    // Contact details

    // Also, if starting a new restaurent how we can help in marketting your restaurent
    // Via, sharing your newly created Profile and Menu link

    return <>
        <h2 className="hide">
            Home Page
        </h2>
        <div>List of Pages and Restaurant</div>
        {/* <ul>
            <li>
                <Link to="/"> Home </Link>
            </li>
        </ul> */}
        <Link to="/"> Home </Link>
        Profile Page [Top clients]
        <Link to="/uduip/profile"> UDUIP Group Restaurent </Link>
        <Link to="/krishna/profile"> Krishna Restaurent </Link>
        <Link to="/rajdhani/profile"> Rajdhani Group Restaurent </Link>
        UDUIP Menu
        <Link to="/uduip/blr-btm"> UDUIP BTM Bangalore Restaurent Menu</Link>
        <Link to="/uduip/mysr-sec6"> UDUIP Sector 6, Mysuru Restaurent Menu</Link>
        404
        <Link to='/randome-url'>Some randome or wrong URL</Link>
    </>
}

export default HomePage;